import { Terminal } from 'lucide-vue-next';
import TerminalPanel from '@/components/panels/TerminalPanel.vue';
import type { PanelOpener } from '@/composables/use-panels.js';

export const createTerminalOpener = (): PanelOpener => ({
	scheme: 'terminal',
	defaultRegion: 'bottom',
	allowedRegions: ['center', 'bottom'],
	resolve(uri) {
		const id = uri.split('//')[1] ?? '1';
		return {
			uri,
			title: `Terminal ${id}`,
			icon: Terminal,
			component: TerminalPanel,
			closable: true,
		};
	},
});
